module.exports = __webpack_public_path__ + "img/10859_S.264f2426.png";